import type { IDataTransferService } from '@/domain/precon-supporter/services/IDataTransferService';

/**
 * インポート実行結果
 */
export interface ImportResult {
  /** マイグレーションが実行されたかどうか */
  migrated: boolean;
  /** 元のデータのバージョン */
  originalVersion: number;
}

/**
 * データインポートユースケース
 *
 * 受講履歴データをインポートする（既存データを上書き）。
 */
export class ImportDataUseCase {
  constructor(private readonly dataTransferService: IDataTransferService) {}

  /**
   * データをインポート
   * @param jsonData インポートするJSONデータ（未検証）
   * @returns インポート結果（マイグレーション情報を含む）
   * @throws Error バリデーションエラーまたはインポートエラー
   */
  async execute(jsonData: unknown): Promise<ImportResult> {
    // バリデーションとマイグレーション
    const result =
      this.dataTransferService.validateAndMigrateImportData(jsonData);

    if (!result.success) {
      throw new Error(result.error);
    }

    // インポート実行
    await this.dataTransferService.importAllData(result.data);

    return {
      migrated: result.migrated,
      originalVersion: result.originalVersion,
    };
  }
}
